import WhiteArrow from '@/assets/icons/whiteArrow.png'
export default function RoundBlueButton(props: any) {

    return (
        <button
            disabled={props.disabled}
            onClick={props.onClick}
            style={{
                cursor: props.disabled ? 'not-allowed' : 'pointer',
                backgroundColor : props.disabled ? '#9f9f9f' : '#1573FE'
            }}
            className='p-[12px] rounded-[50%]'>
            <img                
                className='w-[15px]'
                src={WhiteArrow} about='whiteArrow' />
        </button>
    );
}
